import * as API from '../api/UsersAPI';
import * as ImageAPI from '../api/ImageApi';

export function getAllUsers(order, filterData, token, getAll) {
  return API.getAllUsersNew(order, filterData, token, getAll);
}

export function getUsersByRole(role) {
  return API.getUsersByRole(role);
}

export function searchByEmail(email) {
  return API.searchByEmail(email.toLowerCase());
}

export function deleteUser(userId) {
  return API.deleteUser(userId);
}

export function getUser(id) {
  return API.getById(id);
}

export async function updateUser(user) {
  await API.setRole(user.id, user.role);
  await API.updateUser(user);
}

export function getUserParties(userId) {
  return API.getUserParties(userId);
}

export function resetPassword(email) {
  return API.resetPassword(email);
}

export function getUserStripeCustomers(userId) {
  return API.getUserStripeCustomers(userId);
}

export function getUserStripeCharges(userId, stripeCustomerId) {
  return API.getUserStripeCharges(userId, stripeCustomerId);
}

export const uploadAvatar = async (userId: string, blob: Blob) => {
  const { url, uploadUrl } = await API.getSignedUrl(
    userId,
    'accountManagerAvatar'
  );
  await ImageAPI.uploadImage(uploadUrl, blob);
  return url;
};
